import { useContext, useEffect, useState } from "react";
import logo from "../../assets/logo.png";
import dashboard from "../../assets/dashboard.svg";
import orders from "../../assets/orders.svg";
import profile from "../../assets/profile.svg";
import menuIcon from "../../assets/menu-ico.svg";
import { Dropdown } from "react-bootstrap";
import { useNavigate, Link, Outlet, useLocation } from "react-router-dom";
import {
  fetchQuotationsForSupplier,
  fetchOrderForSupplier,
  getOrginizationDetails,
} from "../../utils/actions/userActions";
import { OrdersContext } from "../../context/orders.context";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import moment from "moment";
import { checkIfAllPartsInvoicedForPO } from "../../utils/helper";
import {
  CalenderIcon,
  CloseIcon,
  DashBoardIcon,
  LogoutIcon,
  MenuIcon,
  OrderIcon,
  UserIcon,
} from "../../component/icons";
import { useInstance } from "../../context/instance.context";

const items = [
  {
    name: "Dashboard",
    Icon: DashBoardIcon,
    href: "/dashboard",
  },
  {
    name: "My Orders",
    Icon: OrderIcon,
    href: "/my-orders",
  },
];

const Navbar = (props) => {
  const [isUserIconClicked, setUserIconClicked] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { ordersCount, setOrdersCount, activeTab, refresh } =
    useContext(OrdersContext);
  const pathNotToShowNavbar = ["/login"];
  const isShowNavBar = !pathNotToShowNavbar.includes(location.pathname);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 700);
  const loggedInUserToken = localStorage.getItem("Token");
  const supplierId = localStorage.getItem("supplierId");
  if (loggedInUserToken) {
    var userfirstName = localStorage.getItem("firstName");
    var userlastName = localStorage.getItem("lastName");
  }
  const [orderCountForDropDown, setOrderCountForDropDown] = useState(0);
  const [logoUrl, setLogoUrl] = useState(null);

  const { name, allInstanceData } = useInstance();
  console.log("Data ::", allInstanceData);

  const handleLogout = () => {
    localStorage.removeItem("Token");
    localStorage.removeItem("_id");
    localStorage.removeItem("firstName");
    localStorage.removeItem("lastName");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("email");
    localStorage.removeItem("pathAfterLogin");
    localStorage.removeItem("currency_meta");
    navigate("/", { state: { from: location.pathname } });
  };
  const token = localStorage.getItem('Token');

  window.addEventListener("resize", () => {
    if (window.innerWidth <= 700) {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  });

  // useEffect(() => {
  //   let decode;
  //   if (loggedInUserToken) {
  //     decode = jwt_decode(loggedInUserToken);
  //     if (!decode) {
  //       navigate("/");
  //       toast.error("Invalid token found!");
  //       return;
  //     } else if (decode.userType == "admin") {
  //       navigate("/");
  //       return;
  //     } else if (decode.exp * 1000 < Date.now()) {
  //       navigate("/");
  //       return;
  //     } else {
  //       // fetchData();
  //     }
  //   } else {
  //     if (!location.pathname.includes("verifyEmail")) {
  //       navigate("/", { state: { from: location.pathname } });
  //       return;
  //     }
  //   }
  // }, []);

  useEffect(() => {
    (async () => {
      try {
        const response = await getOrginizationDetails();
        if (!response || !response.success) {
          throw new Error(response.message)
        }
        const { data } = response;
        setLogoUrl(data.organizationLogo);

      } catch (error) {

      }
    })()

  }, [])



  return (
    <header>
      <nav className=" bg-newPrimaryColor h-16  !px-3.5 md:px-8 lg:!px-12 pt-2 flex items-center    relative">
        <div>
          <div>

            <Link to="/dashboard">
              <img
                className={` ${name == allInstanceData?.NDCS ? "h-6  " : "h-10 mb-2 "}  relative  scale-125 `}
                src={logoUrl} />
            </Link>
          </div>
        </div>

        {loggedInUserToken && (
          <div className="flex justify-between w-full ">
            <ul className={`lg:flex items-center   my-2 hidden ${name == allInstanceData?.NDCS ? "!ms-10 " : ''}`}  >
              {items.length > 0 &&
                items.map(({ name, Icon, href }) => {
                  return (
                    <Link
                      to={href}
                      className="flex items-center mx-2 text-white font-medium no-underline"
                    >
                      <Icon additionalClasses={"h-4 my-1"} />
                      {name}
                    </Link>
                  );
                })}
            </ul>
            <div
              className="lg:flex hidden justify-center items-center  bg-white rounded-full w-8 h-8 my-2 aspect-square"
              onClick={() => setUserIconClicked((pre) => !pre)}
            >
              <UserIcon />
            </div>
            <div
              className={`bg-white w-[150px] border shadown px-2 absolute right-3 top-12 py-2  rounded  ${isUserIconClicked ? "block" : "hidden"
                }`}
            >
              <h1 className="text-xs font-bold mx-2 ">
                {" "}
                {`${userfirstName} ${userlastName}`.toUpperCase()}
              </h1>
              <div className="relative z-[1000]">
                {items.length > 0 &&
                  items.map(({ name, Icon, href }) => {
                    return (
                      <li className="flex items-center gap-x-2 ">
                        <Link
                          to={href}
                          className="flex items-center gap-x-2 my-1 lg:hidden hover:bg-gray-100 p-1 rounded w-full text-black   no-underline font-medium text-sm"
                        >
                          <Icon additionalClasses={"h-4 my-1"} />
                          {name}
                        </Link>
                      </li>
                    );
                  })}

                <li
                  className="flex items-center my-1 hover:bg-gray-100 p-1 rounded gap-x-2 "
                  onClick={handleLogout}
                >
                  <LogoutIcon />
                  <span className="font-medium text-sm">Logout</span>
                </li>
              </div>
            </div>
          </div>
        )}
        {/* ==========MobileHandburgerComponent=============== */}
        {loggedInUserToken && (
          <div className="lg:hidden block">
            {!isUserIconClicked ? (
              <div
                className="handburgur  justify-self-end"
                onClick={() => setUserIconClicked((pre) => !pre)}
              >
                <MenuIcon additionalClass={"h-5 text-white"} />
              </div>
            ) : (
              <div
                className="handburgur  justify-self-end"
                onClick={() => setUserIconClicked((pre) => !pre)}
              >
                <CloseIcon additionalClasses={"h-5 text-white"} />
              </div>
            )}
          </div>
        )}

      </nav>
      {name === allInstanceData?.NDCS && token ? (
        <div className="w-full bg-red-200 text-center py-2 text-sm font-medium text-yellow-900">
          For legacy orders/RFQs created before June 30, 2025, please{' '}
          <a
            href={`${process.env.REACT_APP_LDCS_PORTAL_LINK}?sso=${token}` || "#"}
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-blue-700 font-semibold"
          >
            click here
          </a>{' '}
          to access the old portal.
        </div>
      ) : null}
      <Outlet />
    </header>
  );
};
export default Navbar;
